import { BonusInfo } from "@/typings/bonus"

export const getBonus = async (
  authToken: string,
  options = {}
): Promise<BonusInfo> => {
  const response = await fetch(`${import.meta.env.VITE_API}/data/dailyBonus`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      ...options,
    },
  })

  if (!response.ok) throw new Error("Failed to fetch bonus info")

  return response.json()
}

export const claimBonus = async (authToken: string): Promise<BonusInfo> => {
  const response = await fetch(`${import.meta.env.VITE_API}/data/dailyBonus`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (!response.ok) throw new Error("Failed to claim bonus")

  return response.json()
}
